import React, { Component } from 'react';
import { Col, Row } from 'antd';
import Slider from 'react-slick';
import { apiImageStatic } from '../../../../config/config';
import { responsiveSliderSettings3 } from '../../../utils/utils';

// eslint-disable-next-line react/prefer-stateless-function
class ProductTechnologies extends Component {
  render() {
    const { technologies, productId } = this.props;
    return (
      <>
        <Slider {...responsiveSliderSettings3}>
          {technologies.map((item, i) => {
            return (
              <div key={i.toString()}>
                <Row
                  className="container-technologies-img"
                  type="flex"
                  justify="center"
                  align="middle"
                >
                  <img
                    alt={item.image}
                    className="img-fluid-inv"
                    src={`${apiImageStatic}/technologies/${productId}/${item.image}`}
                  />
                </Row>
                <Row className="mt-20" type="flex" justify="center" align="middle">
                  <Col span={24}>{item.text}</Col>
                </Row>
              </div>
            );
          })}
        </Slider>
      </>
    );
  }
}

export default ProductTechnologies;
